import React from 'react';
import classNames from 'classnames/bind';
import styles from './NotFound.module.scss';
const cx = classNames.bind(styles);
function NotFoundPage() {
    return (
        <div>
            <div className={cx('notfound', 'text-center')}>
                <div className={cx('notfound-404')}>
                    <h1>404</h1>
                </div>
                <h2>Oops! This Page Could Not Be Found</h2>
            </div>
        </div>
    );
}

export default NotFoundPage;
